import React, { useState } from "react";
import swal from "sweetalert";
import {API_BASE} from "./API";
import editar from "./img/editar.jpg";
import excluir from "./img/excluir.jpg";
import loading from "./img/Loading_2.gif";
import 'tailwindcss/tailwind.css';
import recusado from "../src/img/recusado.png";
import duvida from "../src/img/duvida.png";


function IsData(id){

  /******** VALIDA DATA NO FORMATO DD/MM/AAAA *******/
  let stringData = document.getElementById(id).value;  
  let splitData= [];
  let camps =  document.getElementById(id);
  let data_tp = camps.getAttribute("data-tipo");


  if(stringData.length > 0){
          if(stringData.length != 10)
          {
              swal("Data Inválida","","error");
              return false;
          }
 
  let regExpCaracter = /[^\d]/;     //Expressão regular para procurar caracter não-numérico.
  let regExpEspaco = /^\s+|\s+$/g;  //Expressão regular para retirar espaços em branco.

  if(stringData.length != 10)
  {
      swal("Data Inválida","","error");
      return false;
  }

  splitData = stringData.split('/');

  if(splitData.length != 3)
  {                 
      swal("Data Inválida","","error");
      return false;
  }

  /* Retira os espaços em branco do início e fim de cada string. */
  splitData[0] = splitData[0].replace(regExpEspaco, '');
  splitData[1] = splitData[1].replace(regExpEspaco, '');
  splitData[2] = splitData[2].replace(regExpEspaco, '');

  if ((splitData[0].length != 2) || (splitData[1].length != 2) || (splitData[2].length != 4))
  {                   
      swal("Data Inválida","","error");
      return false;
  }

  /* Procura por caracter não-numérico. EX.: o "x" em "28/09/2x11" */
  if (regExpCaracter.test(splitData[0]) || regExpCaracter.test(splitData[1]) || regExpCaracter.test(splitData[2]))
  {                    
      swal("Data Inválida","","error");
      return false;
  }

  let dia = parseInt(splitData[0],10);
  let mes = parseInt(splitData[1],10)-1; //O JavaScript representa o mês de 0 a 11 (0->janeiro, 1->fevereiro... 11->dezembro)
  let ano = parseInt(splitData[2],10);    
  let novaData = new Date(ano, mes, dia);                                    
  let hoje = new Date();              

  if (data_tp == 'DATA_NASC' && novaData > hoje) {
          swal("Data informada não pode ser maior que a data de hoje","","error");
          return false;
      }
      
  
  if ((novaData.getDate() != dia) || (novaData.getMonth() != mes) || (novaData.getFullYear() != ano))
  {       
      swal("Data Inválida","","error");             
      return false;
  }
  else
  {                 
      return true;
  }
}

}

async  function validaInscricao(id){  
  
    
    document.getElementById("btn_confirma").disabled=true;
    document.getElementById("btn_confirma").innerHTML="Aguarde ....";
    document.getElementById("loading").innerHTML="<img src="+loading+" class='loaling' />";
    let validacao = true;
    let validacaox;
    let elementos_campos = document.getElementsByClassName('campos');
    let modo_campo = "analitico";

    //if(tx_modo_campo == "Sintético"){
      //modo_campo = "analitico";
    //}
  
    
    let validacao_campos = [];
    let monta_envio_campos = [];
    let campos_prontos = [];
    let vl;
    let cpp;
    let accumulator;
    let uniqueData;

    Array.prototype.forEach.call(elementos_campos, function(item) { 
      vl="";
      if(item.getAttribute('data_'+modo_campo) == 'S'){
            if(item.getAttribute('data-tipo') === "DATA"  || item.getAttribute('data-tipo') === 'DATA_NASC'){
              vl = item.value.replace(/[^0-9]/g,'');
                if((item.getAttribute('data_obrigatorio') == 'S' && item.value !="") || (item.getAttribute('data_obrigatorio') == 'N' && item.value !="" || (item.getAttribute('data_obrigatorio') == 'S' && item.value ==""))){
                        validacaox = IsData(item.getAttribute('id'));
                        if(!validacaox){
                            validacao_campos.push("<li>"+item.getAttribute('title')+" inválida</li>");
                            validacao = false;
                            item.classList.add("obrigatorio");
                            //item.style.borderColor = "red";
                            vl = "";

                        }
                        else{
                          item.classList.remove("obrigatorio");
                        }
                 }
                 else{
                        vl = "";
                        item.classList.remove("obrigatorio");
                 }

                 monta_envio_campos.push({
                  cod_campo: item.getAttribute('data-cod_campo'), 
                  campo: item.getAttribute('data-campo'), 
                  tipo : item.getAttribute('data-tipo'),
                  value: FormataData('US', item.value),
                  campo_grupo: item.getAttribute('campo_grupo')
                });
       
      }else if(item.getAttribute('data-tipo') === "EMAIL"){
                if((item.getAttribute('data_obrigatorio') == 'S' && item.value !="") || (item.getAttribute('data_obrigatorio') == 'N' && item.value !="" || (item.getAttribute('data_obrigatorio') == 'S' && item.value ==""))){
                                  validacaox = IsEmail(item.value);
                                  if(!validacaox){
                                    validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                                    validacao = false;
                                    item.classList.add("obrigatorio");
                                    vl = "";
                                  }else{
                                    vl = item.value;
                                    item.classList.remove("obrigatorio");
                                  }
                        
                                  if((item.value.length < item.getAttribute('data-min') || item.value.length > item.getAttribute('data-max')))
                                  {
                                    validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                                    validacao = false;
                                    item.classList.add("obrigatorio");  
                                    vl = "";   
                                  }
                                  else{
                                    vl = item.value;
                                    item.classList.remove("obrigatorio");
                                  }

                }
                    monta_envio_campos.push({
                      cod_campo: item.getAttribute('data-cod_campo'), 
                      campo: item.getAttribute('data-campo'), 
                      tipo : item.getAttribute('data-tipo'),
                      value: vl,
                      campo_grupo: item.getAttribute('campo_grupo')
                    });
                

      }else if(item.getAttribute('data-tipo') === "CELULAR_BR" || item.getAttribute('data-tipo') === "FONE_BR"){
        let cel_br = (null != item.value && item.value !=""  ? item.value : '');
        vl = cel_br.replace(/[^0-9]/g,'');
        if((item.getAttribute('data_obrigatorio') == 'S' && cel_br !="") || (item.getAttribute('data_obrigatorio') == 'N' && cel_br !="") || (item.getAttribute('data_obrigatorio') == 'S' && cel_br =="")){
                if((parseInt(vl.length) < parseInt(item.getAttribute('data-min'))) || (parseInt(vl.length) > parseInt(item.getAttribute('data-max'))) || vl == "" 
                || vl =="99999999999" || vl =="88888888888" || vl =="11111111111" || vl =="22222222222" || vl =="33333333333" || vl =="44444444444" || vl =="55555555555" || vl =="66666666666" || vl =="77777777777"
                || vl =="99999999999" || vl =="88888888888" || vl =="1111111111" || vl =="2222222222" || vl =="3333333333" || vl =="4444444444" || vl =="5555555555" || vl =="6666666666" || vl =="7777777777"
                ){
                    validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                    validacao = false;  
                    item.classList.add("obrigatorio");
                    vl="";
                }
                else{
                  item.classList.remove("obrigatorio");
                }
        }
       
          item.classList.remove("obrigatorio");
          monta_envio_campos.push({
            cod_campo: item.getAttribute('data-cod_campo'), 
            campo: item.getAttribute('data-campo'), 
            tipo : item.getAttribute('data-tipo'),
            value: vl,
            campo_grupo: item.getAttribute('campo_grupo')
          });
        
        
    }else if(item.getAttribute('data-tipo') === "FONE_DDI"){
      let cel_br = (null != item.value && item.value !=""  ? item.value : '');
      vl = cel_br.replace(/[^0-9]/g,'');
      if((item.getAttribute('data_obrigatorio') == 'S' && cel_br !="") || (item.getAttribute('data_obrigatorio') == 'N' && cel_br !="") || (item.getAttribute('data_obrigatorio') == 'S' && cel_br =="")){
              if((parseInt(vl.length) < parseInt(item.getAttribute('data-min'))) || (parseInt(vl.length) > parseInt(item.getAttribute('data-max'))) || vl == "" 
              || vl =="99999999999" || vl =="88888888888" || vl =="11111111111" || vl =="22222222222" || vl =="33333333333" || vl =="44444444444" || vl =="55555555555" || vl =="66666666666" || vl =="77777777777"
              || vl =="99999999999" || vl =="88888888888" || vl =="1111111111" || vl =="2222222222" || vl =="3333333333" || vl =="4444444444" || vl =="5555555555" || vl =="6666666666" || vl =="7777777777"
              ){
                  validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                  validacao = false;  
                  item.classList.add("obrigatorio");
                  vl="";
              }
              else{
                item.classList.remove("obrigatorio");
              }
      }
  
        let ddi_n = item.getAttribute('data-ddi');
        item.classList.remove("obrigatorio");
        monta_envio_campos.push({
          cod_campo: item.getAttribute('data-cod_campo'), 
          campo: item.getAttribute('data-campo'), 
          tipo : item.getAttribute('data-tipo'),
          value: ddi_n+"|"+vl,
          campo_grupo: item.getAttribute('campo_grupo')
        });
      
      
  }else if(item.getAttribute('data-tipo') === "CNPJ" || item.getAttribute('data-tipo') === "CPF" ){
               
      vl = (null != item.getAttribute('value') && item.getAttribute('value') !=""  ? item.getAttribute('value') : '');
      vl = vl.replace(/[^0-9]/g,'');
      if((item.getAttribute('data_obrigatorio') == 'S' && vl !="") || (item.getAttribute('data_obrigatorio') == 'N' && vl !="" || (item.getAttribute('data_obrigatorio') == 'S' && vl ==""))){
            if(vl != "" && (parseInt(vl.length) < parseInt(item.getAttribute('data-min')) || parseInt(vl.length) > parseInt(item.getAttribute('data-max')))){
                  validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                  validacao = false;
                  item.classList.add("obrigatorio");  
                  vl="";
              }
              else{
                    item.classList.remove("obrigatorio");
                      if(undefined !== vl &&  parseInt(vl.length)  > 11){
                          validacaox = isValidCNPJ(vl, item.getAttribute('data_obrigatorio'));
                          if(!validacaox){
                              validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                              validacao = false;
                              item.classList.add("obrigatorio");
                              vl="";
                          }
                      }
                      else{
                          validacaox = isValidCPF(vl, item.getAttribute('data_obrigatorio'));
                          if(!validacaox){
                              validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                              validacao = false;
                              item.classList.add("obrigatorio");
                              vl="";
                          }
                      }
                      
              }

              monta_envio_campos.push({
                cod_campo: item.getAttribute('data-cod_campo'), 
                campo: item.getAttribute('data-campo'), 
                tipo : item.getAttribute('data-tipo'),
                value: vl,
                campo_grupo: item.getAttribute('campo_grupo')
               });
      }
      else{
        monta_envio_campos.push({
          cod_campo: item.getAttribute('data-cod_campo'), 
          campo: item.getAttribute('data-campo'), 
          tipo : item.getAttribute('data-tipo'),
          value: "",
          campo_grupo: item.getAttribute('campo_grupo')
         });
        item.classList.remove("obrigatorio");
      }

     
  
  }else if(item.getAttribute('data-tipo') === "CEP" || item.getAttribute('data-tipo') === "NUMERICO" ){
          vl = (null != item.getAttribute('value') && item.getAttribute('value') !="" ? item.getAttribute('value') : '');
          if((item.getAttribute('data_obrigatorio') == 'S' && vl !="") || (item.getAttribute('data_obrigatorio') == 'N' && vl !="") || (item.getAttribute('data_obrigatorio') == 'S' && vl =="")){
                  vl = vl.replace(/[^0-9]/g,'');
                    if((item.getAttribute('data-tipo') === "NUMERICO"  && parseInt(vl.length) < parseInt(item.getAttribute('data-min')) || (parseInt(vl.length) > parseInt(item.getAttribute('data-max')) && item.getAttribute('data-tipo') != "CEP") || (parseInt(vl.length) != 8 && item.getAttribute('data-tipo') === "CEP"))){
                        validacao_campos.push("<li>"+item.getAttribute('title')+" invalido</li>");
                        validacao = false;
                        item.classList.add("obrigatorio");  
                        vl="";
                    }
                    else{
                        item.classList.remove("obrigatorio");
                    }
            }

            monta_envio_campos.push({
              cod_campo: item.getAttribute('data-cod_campo'), 
              campo: item.getAttribute('data-campo'), 
              tipo : item.getAttribute('data-tipo'),
              value: vl,
              campo_grupo: item.getAttribute('campo_grupo')
            });
          
   

}else if(item.getAttribute('data-tipo') === "RADIO" || item.getAttribute('data-tipo') === "TERMO"){
                    
  let checkBoxes = document.getElementsByName(item.getAttribute('name'));
  let selecionados = 0;
  checkBoxes.forEach(function(el) {
      
    if(el.checked) {
        selecionados++;
    }
    
  });
  if(item.getAttribute('data_obrigatorio') == 'S' && (parseInt(selecionados) < parseInt(item.getAttribute('data-min')) || parseInt(selecionados) > parseInt(item.getAttribute('data-max')))){
      validacao_campos.push("<li>"+document.getElementById('RC'+item.getAttribute('name')).getAttribute('title')+", precisa ser selecionado no mínimo:"+parseInt(item.getAttribute('data-min'))+" e no máximo: "+parseInt(item.getAttribute('data-max'))+"</li>");
      validacao = false;
      cpp = document.getElementById('RC'+item.getAttribute('name'));
      cpp.classList.add("obrigatorio2");
  }
  else if(parseInt(selecionados) > 0){

                  if(parseInt(selecionados) >= parseInt(item.getAttribute('data-min')) && parseInt(selecionados) <= parseInt(item.getAttribute('data-max'))){

                                cpp = document.getElementById('RC'+item.getAttribute('name'));
                                cpp.classList.remove("obrigatorio2");
                                    if(item.checked)
                                      {
                                            monta_envio_campos.push({
                                                  cod_campo: item.getAttribute('data-cod_campo'), 
                                                  campo: item.getAttribute('data-campo'), 
                                                  tipo : item.getAttribute('data-tipo'),
                                                  value: item.value,
                                                  campo_grupo: item.getAttribute('campo_grupo')
                                              });
                                      }
                    }
                    else{
                      validacao_campos.push("<li>"+document.getElementById('RC'+item.getAttribute('name')).getAttribute('title')+", precisa ser selecionado no mínimo:"+parseInt(item.getAttribute('data-min'))+" e no máximo: "+parseInt(item.getAttribute('data-max'))+"</li>");
                      validacao = false;
                      cpp = document.getElementById('RC'+item.getAttribute('name'));
                      cpp.classList.add("obrigatorio2");
                    }
         }
         else{
          let exists = monta_envio_campos.some(item2 => item2.cod_campo === item.getAttribute('data-cod_campo'));
              if(!exists && parseInt(selecionados)<=0){
                monta_envio_campos.push({
                  cod_campo: item.getAttribute('data-cod_campo'), 
                  campo: item.getAttribute('data-campo'), 
                  tipo : item.getAttribute('data-tipo'),
                  value: "",
                  campo_grupo: item.getAttribute('campo_grupo')
                });
            } 
          cpp = document.getElementById('RC'+item.getAttribute('name'));
          cpp.classList.remove("obrigatorio2"); 
         }
         

}else if(item.getAttribute('data-tipo') === "CHECKBOX"){
                    
  let checkBoxes = document.getElementsByName(item.getAttribute('name'));
  let camposValues = [];
  let selecionados = 0;
  checkBoxes.forEach(function(el) {
      
    if(el.checked) {
        selecionados++;
        camposValues.push(el.value);
    }
    
  });
  

  if(item.getAttribute('data_obrigatorio') == 'S' && (parseInt(selecionados) < parseInt(item.getAttribute('data-min')) || parseInt(selecionados) > parseInt(item.getAttribute('data-max')))){
      validacao_campos.push("<li>"+document.getElementById('RC'+item.getAttribute('name')).getAttribute('title')+", precisa ser selecionado no mínimo:"+parseInt(item.getAttribute('data-min'))+" e no máximo: "+parseInt(item.getAttribute('data-max'))+"</li>");
      validacao = false;
      cpp = document.getElementById('RC'+item.getAttribute('name'));
      cpp.classList.add("obrigatorio2");
  }
  else if(parseInt(selecionados) > 0){
    let CheckValores = camposValues.length > 0 ? `${camposValues.join("|")}` : "";
                  if(parseInt(selecionados) >= parseInt(item.getAttribute('data-min')) && parseInt(selecionados) <= parseInt(item.getAttribute('data-max'))){

                                cpp = document.getElementById('RC'+item.getAttribute('name'));
                                cpp.classList.remove("obrigatorio2");
                                    if(item.checked)
                                      {
                                            monta_envio_campos.push({
                                                  cod_campo: item.getAttribute('data-cod_campo'), 
                                                  campo: item.getAttribute('data-campo'), 
                                                  tipo : item.getAttribute('data-tipo'),
                                                  value: CheckValores,
                                                  campo_grupo: item.getAttribute('campo_grupo')
                                              });
                                      }
                    }
                    else{
                      validacao_campos.push("<li>"+document.getElementById('RC'+item.getAttribute('name')).getAttribute('title')+", precisa ser selecionado no mínimo:"+parseInt(item.getAttribute('data-min'))+" e no máximo: "+parseInt(item.getAttribute('data-max'))+"</li>");
                      validacao = false;
                      cpp = document.getElementById('RC'+item.getAttribute('name'));
                      cpp.classList.add("obrigatorio2");
                    }
         }
         else{
          let exists = monta_envio_campos.some(item2 => item2.cod_campo === item.getAttribute('data-cod_campo'));
              if(!exists && parseInt(selecionados)<=0){
                monta_envio_campos.push({
                  cod_campo: item.getAttribute('data-cod_campo'), 
                  campo: item.getAttribute('data-campo'), 
                  tipo : item.getAttribute('data-tipo'),
                  value: "",
                  campo_grupo: item.getAttribute('campo_grupo')
                });
            } 
          cpp = document.getElementById('RC'+item.getAttribute('name'));
          cpp.classList.remove("obrigatorio2"); 
         }
         

}else if(item.getAttribute('data-tipo') === "COMBO"){
  
  if((undefined != item.value && null != item.value && item.value != "") && (item.getAttribute('data_obrigatorio') == 'S' && item.value !="") || (item.getAttribute('data_obrigatorio') == 'N' && item.value !="" || (item.getAttribute('data_obrigatorio') == 'S' && item.value =="")))
      {   
             if(item.value == ""){
              validacao_campos.push("<li>"+item.getAttribute('title')+" obrigatório</li>");
              validacao = false;
              item.classList.add("obrigatorio");    
             }
             else{
              item.classList.remove("obrigatorio");   
              }
      }
      
      
      monta_envio_campos.push({
        cod_campo: item.getAttribute('data-cod_campo'), 
        campo: item.getAttribute('data-campo'), 
        tipo : item.getAttribute('data-tipo'),
        value: item.value,
        campo_grupo: item.getAttribute('campo_grupo')
      });

}else if(item.getAttribute('data-tipo') == 'ARQUIVO' || item.getAttribute('data-tipo') == 'UPLOAD_IMG' || item.getAttribute('data-tipo') == 'UPLOAD_DOC'){
  
  if((undefined != item.getAttribute('data-url') && null != item.getAttribute('data-url') && item.getAttribute('data-url') != "") && (item.getAttribute('data_obrigatorio') == 'S' && item.getAttribute('data-url') !="") || (item.getAttribute('data_obrigatorio') == 'N' && item.getAttribute('data-url') !="" || (item.getAttribute('data_obrigatorio') == 'S' && item.getAttribute('data-url') =="")))
      {   
             if(item.getAttribute('data-url') == ""){
              validacao_campos.push("<li>"+item.getAttribute('title')+" obrigatório</li>");
              validacao = false;
              item.classList.add("obrigatorio");    
             }
             else{
              item.classList.remove("obrigatorio");   
              }
      }
      
      
      monta_envio_campos.push({
        cod_campo: item.getAttribute('data-cod_campo'), 
        campo: item.getAttribute('data-campo'), 
        tipo : item.getAttribute('data-tipo'),
        value: item.getAttribute('data-url'),
        campo_grupo: item.getAttribute('campo_grupo')
      });

}else{

      if((undefined != item.value && null != item.value && item.value != "") && (item.getAttribute('data_obrigatorio') == 'S' && item.value !="") || (item.getAttribute('data_obrigatorio') == 'N' && item.value !="" || (item.getAttribute('data_obrigatorio') == 'S' && item.value =="")))
      {   
            if((item.value.length < item.getAttribute('data-min') || item.value.length > item.getAttribute('data-max')))
              {
                validacao_campos.push("<li>"+item.getAttribute('title')+" inválido</li>");
                validacao = false;
                item.classList.add("obrigatorio");    
              }
              else{
                item.classList.remove("obrigatorio");   
              }
         
        }
        
        monta_envio_campos.push({
          cod_campo: item.getAttribute('data-cod_campo'), 
          campo: item.getAttribute('data-campo'), 
          tipo : item.getAttribute('data-tipo'),
          value: item.value,
          campo_grupo: item.getAttribute('campo_grupo')
        });

  }
      
}

monta_envio_campos = monta_envio_campos.reduce((accumulator, current) => {
  if (!accumulator.some(item => item.cod_campo === current.cod_campo && item.value === current.value)) {
      accumulator.push(current);
  }
  return accumulator;
}, []);
                   
    });

    let tipo = sessionStorage.getItem("tipo");
    let categoria = sessionStorage.getItem("categoria");

  
    if(undefined == tipo || null == tipo || tipo == ""){
      validacao_campos.push("<li>Erro 001 - Tipo não informado</li>");
      validacao = false;
    }

    if(undefined == categoria || null == categoria || categoria == ""){
      validacao_campos.push("<li>Erro 002 - Categoria não informada</li>");
      validacao = false;
    }
    
    

    var validacao_campos_limpo = validacao_campos.filter(function(este, i) {
      return validacao_campos.indexOf(este) === i;
    });

    if(!validacao){
      document.getElementById("loading").innerHTML="";
      const wrapper = document.createElement('div');
      wrapper.innerHTML = "<ul className='error_list'>"+validacao_campos_limpo.join('\n')+"</ul>";
      document.getElementById("btn_confirma").disabled=false;
      document.getElementById("btn_confirma").innerHTML="Confirmar";
      swal({
        title: "Corriga os campos conforme o aviso abaixo",
        content: wrapper,
        className: "alert_title", 
        icon: "error"
      });
     
     }
     else{
      let foto =  sessionStorage.getItem("foto");
      if(undefined == foto || null == foto || foto == ""){
        if(undefined != document.getElementById("foto")?.getAttribute("data-arquivo") && null != document.getElementById("foto")?.getAttribute("data-arquivo")){
          foto =  document.getElementById("foto").getAttribute("data-arquivo"); 
        }else{
          foto = "";
        }
      }
      if(undefined == foto || null == foto || foto == ""){
        foto = "";
      }
     
      campos_prontos = {
        'tipo': tipo, 
        'categoria':categoria,
        'cod_inscricao': document.getElementById("cod_inscricao").value, 
        'cod_empresa': document.getElementById("cod_empresa").value,   
        'cod_formulario':sessionStorage.getItem('form'),
        'cod_palestrante ':document.getElementById("cod_palestrante").value,
        "campos":  
             monta_envio_campos
    };


      if(!validaToken()){
        document.getElementById("btn_confirma").disabled=false;
        document.getElementById("btn_confirma").innerHTML="Confirmar";
        document.getElementById("loading").innerHTML="";
        swal("Token Expirado, acesse o link novamente","","error");
        return false;
      }
       //console.log('geral:',JSON.stringify(campos_prontos));  
      //EmContrucao(id);
        EnviarCadastro(JSON.stringify(campos_prontos));
      
    }
    
    
}

function AbreModal(dados){
    const wrapper = document.createElement('div');
    const tabelaHTML = `
    <p>Histórico</p>
    <textarea class='campo_texto_historico' id="campo_texto_historico"></textarea><br />
    <button class='btn_add_historico'>Adicionar +</button> <br /><br />
      <table class="table_historico">
        <thead>
          <tr class="campo_texto_historico_tr">
            <th></th>
            <th></th>
            <th>Histórico</th>
            <th>Data</th>
            <th>Usuário</th>
            <th>Código</th>
          </tr>
        </thead>
        <tbody>
          ${dados.map(item => `
            <tr class="campo_texto_historico_tr">
              <td><input type="checkbox" /></td>
              <td><img src=${editar} title="Editar" /></td>
              <td>${item.historico}</td>
              <td>${item.data}</td>
              <td>${item.usuario}</td>
              <td>${item.cod_historico}</td>
            </tr>
          `).join('')}
          <tr>
              <td></td>
              <td><img src=${excluir} title="Excluir" /></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
        </tbody>
      </table>
    `;
    
    wrapper.innerHTML =tabelaHTML;
    swal({
      title: "Código: - Nome do Inscrito - Histórico",
      content: wrapper,
      className: "table_historico", 
      icon: "",
      button:"Fechar"
    });
    document.getElementById("campo_texto_historico").focus();
}




function IsEmail(email){
  var re = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
  var vl = re.test(email);
       
  
      if(!email || email.indexOf('@')==-1 || email.indexOf('.')==-1 || !vl)
       {    
         return false;
       }
       else{
           return true;
       }
  }

  function isValidCPF(cpf, obrig) {
    // Validar se é String

    if (cpf =='' && obrig == 'N') return true;
    if (cpf =='' || undefined == cpf || cpf.length == 0) { 
        return false
    }
    // Tirar formatação
    cpf = cpf.replace(/[^0-9]/g,'');
    
    // Validar se tem tamanho 11 ou se é uma sequência de digitos repetidos
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
    
    // String para Array
    cpf = cpf.split('')
    
    const validator = cpf
        // Pegar os últimos 2 digitos de validação
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        // Transformar digitos em números
        .map( el => +el )
        
    const toValidate = pop => cpf
        // Pegar Array de items para validar
        .filter((digit, index, array) => index < array.length - pop && digit)
        // Transformar digitos em números
        .map(el => +el)
    
    const rest = (count, pop) => (toValidate(pop)
        // Calcular Soma dos digitos e multiplicar por 10
        .reduce((soma, el, i) => soma + el * (count - i), 0) * 10) 
        // Pegar o resto por 11
        % 11 
        // transformar de 10 para 0
        % 10
        
    return !(rest(10,2) !== validator[0] || rest(11,1) !== validator[1])
}

function isValidCNPJ(cnpj, obrig) {
    if (cnpj =='' && obrig == 'N') return true;
    cnpj = cnpj.replace(/[^0-9]/g,'');
    if(undefined == cnpj || cnpj == '' || cnpj.length == 0) return false;
    if (cnpj.length != 14){
        return false;
    }
 
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" || 
        cnpj == "11111111111111" || 
        cnpj == "22222222222222" || 
        cnpj == "33333333333333" || 
        cnpj == "44444444444444" || 
        cnpj == "55555555555555" || 
        cnpj == "66666666666666" || 
        cnpj == "77777777777777" || 
        cnpj == "88888888888888" || 
        cnpj == "99999999999999")
        return false;  
    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
         
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
     resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;
           
    return true;
}
function EnviarCadastro(dados){
      var requestOptions = {
        method: 'POST',
        body:'[' + dados + ']',
        redirect: 'follow'
    };

    if(sessionStorage.getItem('md') == 'dev'){
        console.log('Cadastro Envio:','[' + dados + ']');
        console.log('Url Cadastro:',API_BASE+"processaCadastro.php?access_token="+sessionStorage.getItem("token")+"&form="+sessionStorage.getItem("form"));
    }

    fetch(API_BASE+"processaCadastro.php?access_token="+sessionStorage.getItem("token")+"&form="+sessionStorage.getItem("form"), requestOptions)
        .then((response) => response.json())
        .then((resultado) => {
            if(sessionStorage.getItem('md') == 'dev'){
                console.log('Resposta Cadastro:', resultado);
            }
        if(resultado.status == "OK" && resultado.cod_inscricao != ""){
           sessionStorage.setItem('cod_inscricao',resultado.cod_inscricao);
           swal("Dados gravados com sucesso","","success").then(()=>{
           // if (window.opener) { // Verifica se a janela tem um "pai"
              document.getElementById("loading").innerHTML="";
              //document.getElementById("btn_confirma").disabled=true;
              //document.getElementById("btn_confirma").innerHTML="Confirmado";
              window.location.href="https://www.geducoficial.com.br/";
            //}
            //else{
              
            //}
            
                /*if(undefined == caminho || null == caminho || caminho == "" || caminho == "3"){
                  window.location.href="/VendaRapida"; 
                }
                else{
                  window.location.href="/Inscricao"; 
                }*/
              
                  //window.location.href="/?id="+sessionStorage.getItem('token')+"&form="+sessionStorage.getItem('form')+"&ref="+sessionStorage.getItem('referencia'); 
            });
                 
        }
        else{   
                document.getElementById("btn_confirma").disabled=false;
                document.getElementById("btn_confirma").innerHTML="Confirmar";
                document.getElementById("loading").innerHTML="";
                swal("Não foi possível atualizar o cadastro","","error");
                return false;
            }
        
        })
        .catch((error) => {
            document.getElementById("btn_confirma").disabled=false;
            document.getElementById("btn_confirma").innerHTML="Confirmar";
            document.getElementById("loading").innerHTML="";
            swal("Não foi possível atualizar o cadastro, retorno não encontrado","","error");
            console.error(error);
            return false;
            
        
        });
        
}

function FormataData(tipo, valor){
  let formato = "";
  
  if(tipo =="BR"){
      valor = valor.replace(" 00:00:00",""); 
      valor = valor.split("-");
      let formato_brasil = valor[2]+valor[1]+valor[0];
      formato = formato_brasil.replace("NaN","");
  }
  else{       
      let vl_n = valor.split("/");
      let formato_americano = vl_n[2]+"-"+vl_n[1]+"-"+vl_n[0];
      valor = formato_americano.replace(" ","");
      formato = formato_americano;
  }
 
 
  return formato;
}


function EmContrucao(id){
  let v="";
  document.getElementById("loading").innerHTML="";
  if(id==1){
    swal("Confirmação Realizada. Obrigado!","","success");
  }
  if(id==2){
    v = duvida;
    swal(
      
      {
        title: "",
        text: "Informado que talvez você compareça. Obrigado!",
        icon: 'error', 
        className:"swal-custom-success"
      });
  }
  if(id==3){
    v = recusado;
    swal(
      {
        title: "",
        text: "Que pena! Obrigado por nos avisar",
        icon: 'error', 
        className:"swal-custom-success"
      }
    );
  }

  if(id==2 || id==3){
        
    setTimeout(() => {
          // Seletor do ícone do SweetAlert
          const icon = document.querySelector('.swal-icon');

          if (icon) {
            // Limpar o conteúdo existente
            icon.innerHTML = '';

            // Criar uma nova imagem para o ícone personalizado
            const customIcon = document.createElement('img');
            customIcon.src = v; // URL do ícone importado
            customIcon.classList.add('icone-diferente'); // Adiciona a classe personalizada

            // Adicionar o ícone ao alerta
            icon.appendChild(customIcon);
          }
        }, 0); // Executa logo após a renderização do alerta

  }
}



function validaToken(){
  if(undefined == sessionStorage.getItem('token') || null == sessionStorage.getItem('token') || "" == sessionStorage.getItem('token')){
    return false;
}
else{
  return true;
}
}


function Sair(){
  sessionStorage.setItem('email','');
  sessionStorage.setItem('pais','');
  sessionStorage.setItem('cpf','');
  window.location.href="/?id="+sessionStorage.getItem("token")+"=&md="+sessionStorage.getItem("md");
}



function CampoReferencia(campo , id_referencia){
  let campo_principal =  document.getElementById(campo);
  let campo_referencia =  "campo"+id_referencia;
  campo_referencia = document.getElementById(campo_referencia);

 
  if(undefined != campo_principal &&  null != campo_principal && (campo_principal.value == null || campo_principal.value =="")){
              let campo_tamanho =  campo_principal.getAttribute('maxlenght'); 
            
              if(undefined != campo_referencia && null != campo_referencia && campo_referencia.value != ""){
                  var texto = campo_referencia.value;
                  if(texto && texto.length > 3){
                      var primeira = texto.substring(0, (texto + " ").indexOf(" "));
                      var ultima = texto.split(" ");
                      let nome_resumido = primeira + " "+ultima[(ultima.length - 1)];
                      campo_principal.value = nome_resumido;
                  }
          }
  }
 
  
}


function AbreUrl(url){
  window.open(url);
  window.location.href="/";
}

function Tira(valor){
  let vl = valor.replaceAll('"','');
  return vl.replaceAll('.','');
}

function validaUpload(campo, dados, tipo, token){
  var _validFileExtensions = dados.split(",");
  let cmp = document.getElementById(campo);
  let oInput = cmp ;
  let t = cmp.getAttribute('maxlength');
  if(undefined == t || t <= 0 ){
      t = 1;
  }
  let tamanho = (t * 1000000);
  if (oInput.type == "file") {
      var sFileName = oInput.value;
       if (sFileName.length > 0) {
          var blnValid = false;
          if(oInput.files[0].size < tamanho){            
                  for (var j = 0; j < _validFileExtensions.length; j++) {
                      var sCurExtension = _validFileExtensions[j];
                          if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                          blnValid = true;
                          
                          EnviaUpload(oInput.files[0], campo, token, tipo);
                         
                          break;
                      }
                  }
                  if (!blnValid) {
                      swal("É permitido somente as extensões: " + _validFileExtensions.join(", "),"","error");
                      oInput.value = "";
                      return false;
                  }
                  
          }
          else{
                  swal("Tamanho máximo permitido  "+t+" mb","","error");
                  oInput.value = "";
                  return false;     
           }
              
           
          
      }
  }
  
}

function EnviaUpload(arquivo, campo, token, tipo){
  let cp = document.getElementById(campo) ;
  let linkk;
  if(undefined == cp || null == cp){
    swal("01 - Não está sendo possível o recebimento do arquivo. Entre em contato com a equipe do suporte","","error");
    return false;
  }
  let ello = document.getElementById('loading');
  let url_up = cp.getAttribute("data-validacao");
  if (!url_up.startsWith("http://") && !url_up.startsWith("https://")) {
    swal("02 - Não está sendo possível o recebimento do arquivo. Entre em contato com a equipe do suporte","","error");
    return false;
  }

  document.getElementById("loading").innerHTML="<img src="+loading+" class='loaling' />";  
  document.getElementById("loading").classList.remove("esconde_primeiro");
  var formdata = new FormData();
  formdata.append("file", arquivo);
  var requestOptions = {
  method: 'POST',
  body: formdata,
  redirect: 'follow'
  };
  if(sessionStorage.getItem('md') == 'dev'){
    console.log(url_up+"&access_token="+token);
  }
 
  fetch(url_up+"&access_token="+token, requestOptions)
  .then(response => response.json())
  .then(result => { 
      if(sessionStorage.getItem('md') == 'dev'){
          console.log('upload:', result);
      }
      if(undefined != result && null != result && result.url !=""){
        document.getElementById("loading").innerHTML="";
        document.getElementById("loading").classList.add("esconde_primeiro"); 
        if(tipo == "IMG_FOTO" || tipo == "UPLOAD_IMG"){
           linkk = document.getElementById("UP"+cp.id);
           if(sessionStorage.getItem('md') == 'dev'){
            console.log("link:",linkk);
           }
           linkk.src=result.url;
           
        }
        else{
          linkk = document.getElementById("TERMO"+cp.id);
          document.getElementById("loading").innerHTML="<a href='"+result.url+"' target='_blank'>Arquivo</a>"; 
        }
        let vl = result.arquivo;
        cp.setAttribute("data-url",vl.replaceAll('"', ''));
      }
      
  
    }

      )
  .catch(error => console.log('error', error));
  
}

function AbreArquivo(campo){
  if( document.getElementById(campo)){
    let url = document.getElementById(campo).src;
    window.open(url);
  }
  else{
    return false;
  }
}

function carregaDDIs(conteudo, id, funcao){
  let $i = 0;
  let trr;
  trr = conteudo;

  const wrapper = document.createElement('div');
    wrapper.innerHTML = "<div style='height:300px;overflow-y:auto;'><input type='text' id='F_"+id+"' style='width:100%;border:1px solid #ccc;' data-id='"+id+"' onkeyup=FiltraParticipante('"+id+"') placeholder='Procure pelo país aqui' /><br /><table class='min-w-full border border-gray-300'>"+trr+"</table></div>";

  swal({
  title: "Escolha o país abaixo",
  content: wrapper,
  className: "alert_title", 
  icon: "",
  closeOnClickOutside: false,
  buttons: {
                                
      confirm: {

      text: 'X', 

      value: "confirm",
      className: "btn-danger"

    }
  }
  
  }); 

  setTimeout(document.getElementById("F_"+id).focus(),100);
}

function ApenasNumeros(campo){
  var nome = document.getElementById(campo).value;
  var tipo = document.getElementById(campo).getAttribute('data-tipo');

  if(tipo !='EMAIL' && tipo !='TEXTO' && tipo !='ALFANUMERICO'){
      nome = nome.replace(/[^0-9]/g,''); 
      document.getElementById(campo).value = (nome != "" ? nome : '');
  }
  if(tipo =='ALFANUMERICO'){
      nome = nome.replace( /\s/g, '' );
      document.getElementById(campo).value = (nome != "" ? nome : '');
  }
  /*if(tipo =='EMAIL'){
      let email = nome;
      email = email.replace(/[^a-zA-Z0-9_@.-]/g, '');
      document.getElementById(campo).value = (email != "" ? email : '');
  } */
}



export default {
    validaInscricao : (id) => validaInscricao(id),
    AbreModal : (dados) => AbreModal(dados),
    IsEmail: (email) => IsEmail(email),
    isValidCPF: (chave, obrig) => isValidCPF(chave, obrig),
    isValidCNPJ: (chave, obrig) => isValidCNPJ(chave, obrig),
    EnviarCadastro: (campos) => EnviarCadastro(campos),
    FormataData : (tipo, valor) => FormataData(tipo, valor),
    EmContrucao:(id) => EmContrucao(id),
    validaToken:() => validaToken(),
    Sair:() => Sair(),
    CampoReferencia:(campo , id_referencia) => CampoReferencia(campo , id_referencia),
    AbreUrl:(url) => AbreUrl(url),
    Tira : (valor) => Tira(valor),
    validaUpload : (campo, dados, tipo, token) => validaUpload(campo, dados, tipo, token),
    AbreArquivo:(campo) => AbreArquivo(campo),
    carregaDDIs : (opcoes, id, funcao) => carregaDDIs(opcoes, id, funcao),
    ApenasNumeros: (campo) => ApenasNumeros(campo)
}